import React from 'react'
import { useDispatch } from 'react-redux'
import { SubmissionError } from 'redux-form'
import { useHistory } from 'react-router-dom'

import { login } from '../../ducks/users'
import Button from '../Shared/Button'
import AuthPage from '../Shared/AuthPage'
import LoginForm from './LoginForm'

export default function Login() {
  const dispatch = useDispatch()
  const history = useHistory()

  const handleLogin = async data => {
    try {
      await dispatch(login(data))
      history.push('/')
    } catch (err) {
      throw new SubmissionError({
        _error: 'Your email / password combination is not correct',
      })
    }
  }

  return (
    <AuthPage
      links={
        <Button text to="/signup">
          No Account? Signup Now
        </Button>
      }
    >
      <LoginForm onSubmit={handleLogin} />
    </AuthPage>
  )
}
